import additionalIdentity from "./components/VerifyAditionalIdentity";
import addMobile from "./components/user/AddMobile";
import pageNotFound from "./components/NotFound";
import verifyUserMobile from "./components/user/VerifyUserMobile";
import profile from "./components/user/Profile";
import redirectToWeb from "./components/user/redirectToWeb";
// import downtime from "./components/downtime.vue";

const importRootComponent=async()=>{
    return import(/* webpackChunkName: "home" */ "./components/Home.vue")
}
const importSingupComponent=async()=>{
    return import(/* webpackChunkName: "signnew" */ "./components/Signup.vue")
}
const importVerifyComponent=async()=>{
    return import(/* webpackChunkName: "verifynew" */ "./components/VerifyOTP.vue")
}
export default [
  // {
  //   path: "/",
  //   component: downtime,
  //   meta: { title: "Sign In / Sign Up", auth: false },
  //   name: "home",
  // },
  {
    path: "/",
    component: importRootComponent,
    meta: { title: "Sign In / Sign Up", auth: false },
    name: "home",
  },
  {
    path: "/sign-up",
    component: importSingupComponent,
    meta: { title: "Sign Up", auth: false },
    name: "sign-up",
  },
  {
    path: "/user/add-mobile",
    component: addMobile,
    meta: { title: "Add Mobile", auth: true },
    name: "add-mobile",
  },
  {
    path: "/verify",
    component: importVerifyComponent,
    meta: { title: "Verify", auth: false },
    name: "verify",
  },
  {
    path: "/verify-identity",
    component: additionalIdentity,
    meta: { title: "Required Additional Identity ", auth: false },
    name: "verify-additional-identity",
  },
  {
    path: "/user/profile",
    component: profile,
    meta: { title: "Profile", auth: true },
    name: "profile",
  },
  {
    path: "/user/verify-mobile",
    component: verifyUserMobile,
    meta: { title: "Verify Mobile", auth: true },
    name: "verify-mobile",
  },
  {
    path: "/redirect-to-website",
    component: redirectToWeb,
    meta: { title: "redirect To Web", auth: true },
    name: "redirect-to-website",
  },
  {
    path: "*",
    component: pageNotFound,
    meta: { title: "Page Not Found", auth: false },
    name: "page-not-found",
  },
];
